import * as tslib_1 from "tslib";
import { AfterViewInit, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './../../../services/login/login.service';
import { tealiumConstants } from './../../../analytics/tealium.constants';
import { TealiumdataService } from './../../../analytics/tealiumdata/tealiumdata.service';
import { TealiumhelperService } from './../../../analytics/tealiumhelper/tealiumhelper.service';
import { debounceTime, delay } from 'rxjs/internal/operators';
import { fromEvent } from 'rxjs';
import { TabsService } from './../../tabs/tabs.service';
import { OrderDetailsService } from './../../../services/order-details/order-details.service';
import { StorageService } from './../../../services/storage/storage.service';
import { UiConfigService } from './../../../config/ui-config/ui-config.service';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(_doc, _auth, router, tagHelperService, tealiumDataService, tabsService, renderer, elementRef, orders, _storage, uiConfig) {
        this._doc = _doc;
        this._auth = _auth;
        this.router = router;
        this.tagHelperService = tagHelperService;
        this.tealiumDataService = tealiumDataService;
        this.tabsService = tabsService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.orders = orders;
        this._storage = _storage;
        this.uiConfig = uiConfig;
        this.isMenuActive = false;
        this.currentPath = this.router.url;
        this.nav = [];
        this.viewConfig = {};
        this.envHost = '/';
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.url = window.location.origin + '/pharmacy/#/pharmacy';
        // Subscribe to logged in user
        this._auth.authState.pipe(delay(1000)).subscribe(function (state) {
            _this.user = state.data;
            _this.userName = state && state.careGiver
                ? (state.careGiver.firstName || '')
                : (_this.user
                    ? _this.user.firstName
                    : '');
            if (state.authenticated && (state.rxTied || state.caregivee)) {
                _this.tabsService.asyncTabs.pipe(delay(500)).subscribe(function (tabs) {
                    _this.nav = _this.resolveNavs(tabs);
                });
            }
        });
        // intial view config
        this.viewConfig = this.uiConfig.setup(this.router.url);
        // Subscribe to window resize but debounce 1s
        fromEvent(window, 'resize')
            .pipe(debounceTime(500))
            .subscribe(function (evt) {
            _this.resize();
        });
    };
    HeaderComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var li = this.elementRef.nativeElement.querySelectorAll('.toggle-nav');
        for (var i = 0; i < li.length; i++) {
            this.renderer.listen(li[i], 'click', function () {
                _this.viewConfig = _this.uiConfig.setup(_this.router.url);
                _this.isMenuActive = !_this.isMenuActive;
                _this.mobileHeader.nativeElement.classList.toggle('open');
            });
        }
    };
    HeaderComponent.prototype.tabNav = function (url, evt) {
        this.isMenuActive = false;
        this.mobileHeader.nativeElement.classList.remove('open');
        evt.preventDefault();
        var reg = /[A-Za-z]+/;
        url = url.match(reg);
        this.router.navigateByUrl("/" + url);
    };
    /**
     * Function used to remove tabs that should be hidden
     */
    HeaderComponent.prototype.resolveNavs = function (navs) {
        return navs.filter(function (nav) { return !(nav.class && nav.class === 'hide'); });
    };
    /**
     * Close sidebar on resize
     */
    HeaderComponent.prototype.resize = function () {
        var mobileMenu = this.mobileHeader.nativeElement;
        if (window.innerWidth >= 768 && mobileMenu.classList.contains('open')) {
            mobileMenu.classList.remove('open');
            this.isMenuActive = false;
        }
    };
    /**
     * Sign out user but fire a tag before doing so
     * Display spinner in the mean while
     */
    HeaderComponent.prototype.signOut = function () {
        this.isMenuActive = false;
        this.mobileHeader.nativeElement.classList.remove('open');
        this.sendTag('signout');
    };
    /**
     * Send a tag before redirecting to pharmacy
     */
    HeaderComponent.prototype.applyPharmacyTag = function ($event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, target, url;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        $event.preventDefault();
                        data = Object.assign(this.tealiumDataService.getDefault(null, tealiumConstants.pageNameHeader, tealiumConstants.pageCategory), tealiumConstants.cvsPharmacy);
                        target = $event.target;
                        url = target.getAttribute('href');
                        return [4 /*yield*/, this.tagHelperService.link(data, function () {
                                window.location.href = url;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype.toggleMenu = function (state) {
    };
    HeaderComponent.prototype.sendTag = function (type, url) {
        if (type === 'signout') {
            var data = Object.assign(this.tealiumDataService.getDefault(null, tealiumConstants.pageNameHeader, tealiumConstants.pageCategory), tealiumConstants.signOut);
            this.tagHelperService.link(data);
        }
        if (type === 'tabNav') {
            var data = Object.assign(this.tealiumDataService.getDefault(null, tealiumConstants.pageNameSideBar, tealiumConstants.pageCategory), {
                link_name: "Custom:mdp:sidebar:" + url,
                link_trackvars: 'events',
                link_trackevents: 'event00'
            });
            this.tagHelperService.link(data);
        }
    };
    return HeaderComponent;
}());
export { HeaderComponent };
